<template>
  <div class="auditlog">
    <el-scrollbar class="auditlog_el">
      <div class="each_auditlog_log"
           v-for='item in operateLos'>
        <div class="each_auditlog_time">{{item.time_create | formatTime}}</div>
        <div class="audit_log_person">
          <img src="../../../static/img/avatar.png"
               alt=""
               v-if='!item.head_img'>
          <img :src="item.head_img"
               alt=""
               v-if='item.head_img'>
          <span class="name">{{item.user_name}}</span>
        </div>
        <div class="audit_log_send">
          <span class="send_title">{{item.content}}</span>
          <span v-if='item.to_user_name'
                class="send_title"
                style="color:#688eff;">{{item.to_user_name}}</span>
        </div>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
import { getUrlCode } from '../../../utils/index.js'
import * as api from '../../../api'
export default {
  name: 'operatelogs',
  data() {
    return {

    }
  },
  created() {

  },
  components: {

  },
  computed: {
    operateLos() {
      return this.$store.state.logs.operateLos
    }
  },
  mounted() {


  },
  destroyed() {

  },
  methods: {


  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='stylus' scoped>
@import '../../../styles/audit_comment.styl'
</style>
